import ScalarVirtualCodeBlock_vue_vue_type_script_setup_true_lang_default from "./ScalarVirtualCodeBlock.vue.script.js";
//#region src/components/ScalarVirtualCodeBlock/ScalarVirtualCodeBlock.vue
var ScalarVirtualCodeBlock_default = ScalarVirtualCodeBlock_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarVirtualCodeBlock_default as default };

//# sourceMappingURL=ScalarVirtualCodeBlock.vue.js.map